import { uploadResourceFile, loadResourceFiles, hideAllNewMigrationParameters } from '@/core/migration/supportMigrationFunctions'
import { getLocalizedMessage, showMessageAlert } from '@/core/shared'
import { bindResetButtonModal } from '@/core/input_controls/button/button'
import { getDataFromBoolean } from '@/core/item_assistance/receiveDataFromComponents'

export function NewExportConfigManager (companyId) {
	this.global = !companyId

	this.transformationType = ''
	this.exportTypes = []
	this.migrationConfig = {}

	this.setExportTypes = function (exportTypes) {
		this.exportTypes = exportTypes
	}

	this.renderExportTransformationParameters = function () {
		if (this.transformationType !== '') {
			$('#migration-parameters').css('display', 'block')
			$('#migration-debug-mode').css('display', 'block')
		}

		if (this.transformationType === 'EXCEL') {
			this.renderExportExcelTemplate()
		}
		if (this.transformationType === 'XML') {
			this.renderExportXmlTemplate()
		}
		if (this.transformationType === 'PDF') {
			this.renderExportPdfTemplate()
		}
		if (this.transformationType === 'JSON') {
			this.renderExportJsonTemplate()
		}
	}

	this.renderExportExcelTemplate = function () {
		$('#migration-excel-stream-output').css('display', 'block')
		$('#migration-required-fields-only').css('display', 'block')
		$('#migration-left-attribute-names').css('display', 'block')
		$('.xslt-file_select').css('display', 'block')
		$('.file-input_excelTemplate').css('display', 'block')
		$('.excel-template-sample').css('display', 'block')
		$('.filename-pattern').css('display', 'block')
	}

	this.renderExportXmlTemplate = function () {
		$('#migration-required-fields-only').css('display', 'block')
		$('.xslt-file_select').css('display', 'block')
		$('.filename-pattern').css('display', 'block')
	}

	this.renderExportJsonTemplate = function () {
		$('#migration-required-fields-only').css('display', 'block')
		$('.xslt-file_select').css('display', 'block')
		$('.filename-pattern').css('display', 'block')
	}

	this.renderExportPdfTemplate = function () {
		$('.xslt-file_select').css('display', 'block')
		$('.filename-pattern').css('display', 'block')
	}

	this.initNewMigrationForm = function (table) {
		var manager = this
		Swal.fire({
			title: getLocalizedMessage('create.configuration'),
			html: '<div class="modal_item">\n' +
				'    <div class="new-migration_name">\n' +
				'        <label id="migration-name_label" for="migration-name">' + getLocalizedMessage('configuration.name') + '</label>\n' +
				'        <br>\n' +
				'        <input id="migration-name" type="text" class="textInput attribute-editor">\n' +
				'        <button class="button_reset fa fa-times"></button>\n' +
				'    </div>\n' +
				'</div>\n' +
				'<div class="modal_item">\n' +
				'    <div id="new-migration_transformation-tag" class="new-migration_transformation-tag">\n' +
				'        <label id="transformation-tag_label" for="transformation-tag">' + getLocalizedMessage('transformation.tag') + '</label>\n' +
				'        <br>\n' +
				'        <select id="transformation-tag" class="select attribute-editor">\n' +
				'\n' +
				'        </select>\n' +
				'    </div>\n' +
				'</div>\n' +
				'<div class="modal_item">\n' +
				'    <div class="new-migration_transformation-type">\n' +
				'        <label id="transformation-type_label" for="transformation-type">' + getLocalizedMessage('transformation.type') + '</label>\n' +
				'        <br>\n' +
				'        <select id="transformation-type" class="select attribute-editor">\n' +
				'            <option value=""></option>\n' +
				'        </select>\n' +
				'    </div>\n' +
				'</div>\n' +
				'<div class="modal_item">\n' +
                '    <p id="transformation-type-limit" class="transformation-type-limit" style="display:none"></p>\n' +
                '</div>\n' +
				'<div class="modal_item">\n' +
				'    <div class="new-migration_parameters migration-paramters">\n' +
				'        <br>\n' +
				'        <div class="modal_item"><label id="migration-parameters" style="display: none">' + getLocalizedMessage('migration.parameters') + '</label></div>\n' +
				'        <div id="migration-debug-mode" class="modal_item" style="display: none">\n' +
				'            <label for="debug-mode">' + getLocalizedMessage('debug.mode') + '</label>\n' +
				'            <input type="checkbox" class="checkbox-bool" id="debug-mode">\n' +
				'        </div>\n' +
				'        <div id="migration-excel-stream-output" class="modal_item" style="display: none">\n' +
				'            <label for="required-fields-only">' + getLocalizedMessage('migration.excel.stream.output') + '</label>\n' +
				'            <input type="checkbox" class="checkbox-bool" id="excel-stream-output">\n' +
				'        </div>\n' +
				'        <div id="migration-required-fields-only" class="modal_item" style="display: none">\n' +
				'            <label for="required-fields-only">' + getLocalizedMessage('migration.required.fields.only') + '</label>\n' +
				'            <input type="checkbox" class="checkbox-bool" id="required-fields-only">\n' +
				'        </div>\n' +
				'        <div id="migration-left-attribute-names" class="modal_item" style="display: none">\n' +
				'            <label for="left-attribute-names">' + getLocalizedMessage('migration.left.attribute.names') + '</label>\n' +
				'            <input type="checkbox" class="checkbox-bool" id="left-attribute-names">\n' +
				'        </div>\n' +
				'        <div class="csv-format-list modal_item" style="display: none">\n' +
				'            <label id="csv-format-list_label" for="csv-format-list">' + getLocalizedMessage('csv.format.list') + '</label>\n' +
				'            <br>\n' +
				'            <select id="csv-format-list" class="select attribute-editor">\n' +
				'                <option value="default">default</option>\n' +
				'                <option value="excel">excel</option>\n' +
				'                <option value="excel_semicolon">excel_semicolon</option>\n' +
				'                <option value="mysql">mysql</option>\n' +
				'                <option value="rfc4180">rfc4180</option>\n' +
				'                <option value="tdf">tdf</option>\n' +
				'            </select>\n' +
				'        </div>\n' +
				'        <div class="filename-pattern modal_item" style="display: none">\n' +
				'            <div class="new-migration_filename-pattern">\n' +
				'                <label id="transformation-type_label" for="filename-pattern">' + getLocalizedMessage('filename.pattern') + '</label>\n' +
				'                <br>\n' +
				'                <input id="filename-pattern" type="text" class="textInput attribute-editor">\n' +
				'            </div>\n' +
				'        </div>\n' +
				'        <div class="xslt-file_select modal_item" style="display: none">\n' +
				'            <label>' + getLocalizedMessage('xslt.file') + '</label>\n' +
				'            <div class="modal_item">\n' +
				'                <select id="xslt-file" class="select select-with-add attribute-editor"></select>\n' +
				'                <input id="xslt-file-input" class="attribute-editor" type="file" accept=".xsl" style="display:none;"/>\n' +
				'                <button id="xslt-file-button" class="button_plus fa fa-plus" tabindex="-1"></button>\n' +
				'            </div>\n' +
				'        </div>\n' +
				'        <div class="file-input_excelTemplate modal_item" style="display: none">\n' +
				'            <label>' + getLocalizedMessage('export.template') + '</label>\n' +
				'            <div class="modal_item">\n' +
				'                <select id="excel-template" class="select select-with-add attribute-editor"></select>\n' +
				'                <input id="excel-template-input" class="attribute-editor" type="file" accept=".xlsx,.xls" style="display:none;"/>\n' +
				'                <button id="excel-template-button" class="button_plus fa fa-plus" tabindex="-1"></button>\n' +
				'            </div>\n' +
				'        </div>\n' +
				'        <div class="excel-template-sample modal_item" style="display: none">\n' +
				'            <a onclick="downloadManager(\'/export-config/excel/template\')">' + getLocalizedMessage('migration.excel.template.sample') + '</a>\n' +
				'        </div>\n' +
				'        <div class="string-value_1 modal_item" style="display: none">\n' +
				'            <label id="string-value-1_label" for="string-value-1"></label>\n' +
				'            <br>\n' +
				'            <input id="string-value-1" type="text" class="textInput attribute-editor">\n' +
				'            <button class="button_reset fa fa-times"></button>\n' +
				'        </div>\n' +
				'        <div class="string-value_2 modal_item" style="display: none">\n' +
				'            <label id="string-value-2_label" for="string-value-2"></label>\n' +
				'            <br>\n' +
				'            <input id="string-value-2" type="text" class="textInput attribute-editor modal_item">\n' +
				'            <button class="button_reset fa fa-times"></button>\n' +
				'        </div>\n' +
				'        <div class="file-input_importSample modal_item" style="display: none">\n' +
				'            <label>' + getLocalizedMessage('import.sample') + '</label>\n' +
				'            <div class="modal_item">\n' +
				'                <input id="import-sample" class="attribute-editor" type="file"/>\n' +
				'            </div>\n' +
				'        </div>\n' +
				'    </div>\n' +
				'</div>',
			confirmButtonText: getLocalizedMessage('save'),
			showCancelButton: true,
			cancelButtonText: getLocalizedMessage('cancel'),
			buttonsStyling: false,
			allowOutsideClick: false,
			allowEnterKey: true,
			showClass: {
				popup: ''
			},
			hideClass: {
				popup: ''
			},
			customClass: {
				content: 'form',
				confirmButton: 'uk-button uk-button-primary uk-button-small uk-margin-small-right',
				cancelButton: 'uk-button uk-button-default uk-button-small',
			},
			onRender: function () {
				manager.bindAddResourceButtons()

				loadResourceFiles($('#xslt-file'), 'xslt', true, !manager.global)
				loadResourceFiles($('#excel-template'), 'excel', true, !manager.global)

				hideAllNewMigrationParameters()
				manager.renderNewMigrationTransforms()
				tagManager.getTags()
				bindResetButtonModal()
			},
			preConfirm: function (inputValue) {
				manager.getNewMigrationParameters()
				return manager.migrationConfig
			}
		}).then(function (result) {
			if (result.value) {
				manager.createMigration(table)
			}
		})
	}

	this.bindAddResourceButtons = function () {
		var manager = this

		var excelTemplateInputSelector = $('#excel-template-input')
		excelTemplateInputSelector.unbind('change')
		excelTemplateInputSelector.change(function () {
			var file = Array.from(excelTemplateInputSelector.get(0).files)[0]
			excelTemplateInputSelector.get(0).value = ''
			if (file == null) {
				return
			}

			uploadResourceFile(manager.global, file, function (data) {
				var name = data['name']
				if (manager.global) {
					name = 'global/' + name
				}
				loadResourceFiles($('#excel-template'), 'excel', true, !manager.global, name)
			})
		})

		var excelTemplateButtonSelector = $('#excel-template-button')
		excelTemplateButtonSelector.unbind('click')
		excelTemplateButtonSelector.click(function () {
			excelTemplateInputSelector.click()
		})

		var xsltFileInputSelector = $('#xslt-file-input')
		xsltFileInputSelector.unbind('change')
		xsltFileInputSelector.change(function () {
			var file = Array.from(xsltFileInputSelector.get(0).files)[0]
			xsltFileInputSelector.get(0).value = ''
			if (file == null) {
				return
			}

			uploadResourceFile(manager.global, file, function (data) {
				var name = data['name']
				if (manager.global) {
					name = 'global/' + name
				}
				loadResourceFiles($('#xslt-file'), 'xslt', true, !manager.global, name)
			})
		})

		var xsltFileButtonSelector = $('#xslt-file-button')
		xsltFileButtonSelector.unbind('click')
		xsltFileButtonSelector.click(function () {
			xsltFileInputSelector.click()
		})
	}

	this.renderNewMigrationTransforms = function () {
		var manager = this

		var transformationTypeSelector = $('#transformation-type')
		transformationTypeSelector.empty()
		transformationTypeSelector.append('<option value=\'\'></option>')
		_.each(this.exportTypes, function (type) {
			transformationTypeSelector.append('<option value=\'' + type + '\'>' + type + '</option>')
		})

		transformationTypeSelector.change(function () {
			manager.transformationType = transformationTypeSelector.val()
			manager.renderNewTransformationParameters()
			manager.renderTransformationTypeLimit()
		})
	}

	this.renderTransformationTypeLimit = function () {
        var limits = {
                EXCEL: getLocalizedMessage('export.limit.excel'),
                PDF: getLocalizedMessage('export.limit.pdf')
        }
        var text = limits[this.transformationType]
        $('#transformation-type-limit').text(text || '').css('display', text ? 'block' : 'none')
  	}

	this.renderNewTransformationParameters = function () {
		hideAllNewMigrationParameters()
		this.renderExportTransformationParameters()
	}

	this.createMigration = function (table) {
		var prefix = this.global ? 'global/' : ''
		var url = window.urlContext + prefix + 'export-config/save'

		$.ajax({
			url: url,
			type: 'POST',
			async: true,
			context: this,
			contentType: 'application/json; charset=UTF-8',
			data: JSON.stringify(this.migrationConfig),
			success: function (data) {
				table.initTable()
				showMessageAlert(getLocalizedMessage('success'), 'success')
			},
			error: function () {
				showMessageAlert(getLocalizedMessage('error'), 'danger')
			}
		})
	}

	this.getNewMigrationParameters = function () {
		this.migrationConfig['name'] = $('#migration-name').val()
		this.migrationConfig['type'] = this.transformationType
		this.migrationConfig['companyId'] = companyId
		this.migrationConfig['tagId'] = nullOnEmpty($('#transformation-tag').val())

		var params = {
			debug: getDataFromBoolean('debug-mode')
		}

		var xslt = $('#xslt-file').val()
		if (xslt) {
			params.xslt = [xslt]
		}
		var filenamePattern = $('#filename-pattern').val();
		if (filenamePattern) {
			params.filenamePattern = filenamePattern;
		}

		if (this.transformationType === 'XML') {
			params.requiredFieldsOnly = getDataFromBoolean('required-fields-only')
		} else if (this.transformationType === 'EXCEL') {
			params.requiredFieldsOnly = getDataFromBoolean('required-fields-only')
			params.leftAttributeNames = getDataFromBoolean('left-attribute-names')
			params.excelStreamOutput = getDataFromBoolean('excel-stream-output')
			params.excelTemplate = nullOnEmpty($('#excel-template').val())
		} else if (this.transformationType === 'JSON') {
			params.requiredFieldsOnly = getDataFromBoolean('required-fields-only')
		} else if (this.transformationType === 'PDF') {
		}

		this.migrationConfig.parameters = params

		function nullOnEmpty (value) {
			return value !== '' ? value : null;
		}
	};
}
